import type { RefObject } from "react";

export const scrollIntoView = (ref: RefObject<HTMLDivElement | null>) => {
	setTimeout(() => {
		ref?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
	}, 300);
};
